import React from 'react'
import { TransferSuccess as TransferSuccessType } from '../../../types/helmetLookup'

interface TransferSuccessProps {
  transferSuccess: TransferSuccessType
}

const TransferSuccess: React.FC<TransferSuccessProps> = ({ transferSuccess }) => {
  return (
    <div className="bg-success/10 border-l-4 border-success p-3 sm:p-4 lg:p-6 rounded-lg w-full" role="group" aria-labelledby="transfer-success-heading">
      <div className="flex flex-col sm:flex-row sm:items-center space-y-2 sm:space-y-0 sm:space-x-3 mb-3 sm:mb-4">
        <div className="bg-success text-white rounded-full w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center font-bold text-xs sm:text-sm lg:text-base flex-shrink-0">
          <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
          </svg>
        </div>
        <h3 id="transfer-success-heading" className="text-base sm:text-lg lg:text-xl font-heading font-bold text-success">TRANSFER COMPLETED SUCCESSFULLY</h3>
      </div>
      
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2 sm:gap-3 text-xs sm:text-sm w-full">
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">Helmet</span>
          <span className="text-sm sm:text-base font-bold text-riddell-red">{transferSuccess.helmetDisplay}</span>
        </div>
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">From</span>
          <span className="text-sm sm:text-base font-medium text-riddell-black break-words leading-tight">{transferSuccess.sourceDisplay}</span>
        </div>
        <div className="bg-white p-2 sm:p-3 rounded-md shadow-sm w-full">
          <span className="block text-xs font-bold text-riddell-black uppercase tracking-wide mb-0.5">To</span>
          <span className="text-sm sm:text-base font-medium text-riddell-black break-words leading-tight">{transferSuccess.targetDisplay}</span>
        </div>
      </div>
    </div>
  )
}

export default TransferSuccess
